<template>
	<!-- islanders2023_eventSubmission -->
	 <div id="membersOnly" class="membersOnly" >

		 <div class=" py-5 memberJackets_section">
			 <div class="content_container">
				 <SectionHeader subTitle="CUSTOMIZE YOUR BENEFITs" topText="EXCLUSIVE MEMBER" middleText=" EVENTS" textColor="blue" textAlign="center"/>

				 <div class="content">
					 <p>
						 New this year, members can customize their benefits by choosing additional events and gifts.
						 Check out the awesome options below!
					 </p>

				 </div>
			 </div>
			 <div class="optionWrapper">
				 <div class="grid">
					 <div
					 class="grid_item"
					 v-for="(option, index) in options"
					 :key="index"

					 >
					 	<div class="img_checkbox">
							  <span class="box-box-box" >
						        <img
						  	      :src="require(`@/assets/images/membersOnly/${option.img}`)"
						          alt="check"
						        />
						      </span>

						      <h2 class="title">{{ option.title }}</h2>
							  <p>{{option.description}}</p>

						  </div>
				 	</div>


			 	</div>

		 	</div>


		 </div>
	 </div>
</template>

<script>

import SectionHeader from "@/components/SectionHeader";
export default {
  name: "CustomizeEvents",
  components: { SectionHeader },
  data() {
	   return {
		 modalActive: false,
		 options:
		 [
			{
				title: "Family Skate & Holiday Photo Shoot",
				description: "Skate on the ice at UBS Arena while grabbing some Isles-themed holiday photos.",
				checkboxLable: "Select this event",
				img: "ben-skate.jpg",
				active: false,
			},
			{
				title: "Invite to Watch Party",
				description: "Join us for an exclusive Member watch party during a select away game.",
				checkboxLable: "Select this event",
				img: "ben-party.jpg",
				active: false,
			},
			{
				title: "Alumni Meet & Greet",
				description: "Mix and mingle with Isles alumni from the team’s storied history.",
				checkboxLable: "Select this event",
				img: "ben-meet.jpg",
				active: false,
			},
			{
				title: "Banner Photo Night",
				description: "Head to UBS Arena as we lower our historic banners for Members to take photos with.",
				checkboxLable: "Select this event",
				img: "ben-photo-night.jpg",
				active: false,
			},
			{
				title: "Paint The Ice Event",
				description: "Draw your own masterpiece or leave a message of support on the ice at UBS Arena.",
				checkboxLable: "Select this event",
				img: "ben-paint.jpg",
				active: false,
			},
		 ],
	   };
	 },
};
</script>

<style lang="scss" scoped>
.membersOnly{
	padding: 50px 0;
	background-size:cover !important;
	background-repeat: no-repeat !important;
	background: theme-var($--ch-theme-secondary);
	@media screen and (min-width: 1600px) {
		// background-size:cover !important;
	}
	@include media-breakpoint-down(sm) {
		// background-image :linear-gradient(to bottom, rgba(202, 152, 41, 0.2) 27%, rgba(202, 152, 41, 1) 49%),url("~images/membersOnly/bg-jacket-mobile.jpg");
	  // background: url("~images/membersOnly/bg-jacket-mobile.jpg");
	  background-repeat: no-repeat;
	  background-size:contain !important;
	}
	.memberJackets_section{

		@include media-breakpoint-down(sm) {

	    }
		.content_container{

			@include media-breakpoint-down(sm) {
				// padding-left: 50px;
				// text-align: center;
			}
			.content{
				max-width:550px;
				margin: 30px auto;
				@include media-breakpoint-down(sm) {
					padding: 0px 30px;
				}
			}

			h1{
				color: theme-var($--ch-theme-primary);
				padding-bottom: 20px;
				//font-family: "AntaTrial-UltExpExtBd";
				font-size: 40px;
				@include media-breakpoint-down(sm) {
					font-size: 30px;
				}
			}
			h4{
				//font-family: "AntaTrial-UltExpExtBd";
				font-size: 14px;
				// color: #00478A;
				color: theme-var($--ch-theme-primary);
				letter-spacing: 0;
				font-weight: 900;
				@include media-breakpoint-down(sm) {
					font-size: 11px;
				}
			}
			p{
			  color: theme-var($--ch-theme-primary);
			  font-family: "GeogrotesqueSharp-Md";
	  		  font-size: 18.5px;
	  		  letter-spacing: 0;
	  		  line-height: 140%;
	  		  font-weight: 500;
			  text-align:center;

			}
		}
		.img_container{
			position: relative;
			margin-bottom: 30px;

			@include media-breakpoint-down(sm) {
				margin-top: 30px;
			}

			.player_img {
				height:350px;
				// position: relative;
				margin-left: 170px;
				// top: 80px;
				// left: 185px;
				z-index:10;
				// box-shadow: 5px 5px 20px #aaaaaa;
				@include media-breakpoint-down(sm) {
			      height:275px;
				  margin-left: 35px;
			    }
			}
			    // flex-direction: column;

		}


	}

	.optionWrapper{
		padding:10px 30px;
		@include media-breakpoint-down(sm) {
		  // grid-template-columns: repeat(1, 0fr);
		   padding:10px;
		}
		.grid{
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
	   		align-items:  flex-start;
			  padding:10px;
			//padding:0px 100px;
			  @include media-breakpoint-down(sm) {
			    // grid-template-columns: repeat(1, 0fr);
			     padding:10px;
				 justify-content: flex-start;
				align-items:  flex-start;
			  }
			  @media only screen and (min-width: 578px) and (max-width: 900px)  {
				 padding:10px;
 				 align-items:  flex-start;
			  }
			  @media only screen and (min-width: 900px) and (max-width: 1200px) {
				  padding:10px;
				 align-items:  flex-start;
			  }

			.grid_item{
				flex: 0 0 33.33%;
			 	padding:20px 20px;
				margin: 10px;
			 	// background: rgba(0,0,0,0.54);
				@include media-breakpoint-down(sm) {
					//flex: 1;
					// flex-grow: 1;
		    	    padding: 10px;
					margin: 10px 0px;
					// padding:20px 20px;
		  		    // height: 300px;
				}
				@media only screen and (min-width: 578px) and (max-width: 900px)  {
					//flex: 0 0 33.33%;
				}

			 	img{
					margin-bottom:20px;
					width: 100%;
					// height:270px;
					// width:auto;
					@include media-breakpoint-down(sm) {
					  height:175px;
					  width:auto;
					}
					@media only screen and (min-width: 578px) and (max-width: 900px)  {
						height:150px;
						width:auto;
					}
					@media only screen and (min-width: 900px) and (max-width: 1200px) {
						height:210px;
						width:auto;
					 }
				}
			 	h2{
					font-family: "GeogrotesqueSharp-Bd";
					font-size: 26px;
					color: theme-var($--ch-theme-primary);
					letter-spacing: 0;
					line-height: 34px;
					font-weight: 700;
					@include media-breakpoint-down(sm) {
					  font-size: 18px;
					  line-height: 24px;
					}
				}
				p{
					font-family: "GeogrotesqueSharp-Md";
					font-size: 18.5px;
					color: theme-var($--ch-theme-primary);
					letter-spacing: 0;
					line-height: 20px;
					font-weight: 500;
					@include media-breakpoint-down(sm) {
					  // font-size: 14px;
					}
				}
			}
		}
	}
}
@media only screen and (min-width: 578px) and (max-width: 900px){
	.brickProgram{
		.memberJackets_section{
			flex-direction:column;
  		  flex-wrap: wrap;
		}
	}
}
</style>
